import type { RouteLocationNormalized } from 'vue-router'

/**
 * Check that the next route location has a "params" params and that it changed compare to previous route
 * @param to the next route location
 * @param from the current route location
 * @returns true if params is new or changed
 */
export function hasParamsChanged(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  params: 'thread_id' | 'facet_uri' | 'content_type' | 'derived_type_id',
) {
  if (!(params in to.params))
    return false

  // @ts-expect-error typescript inference is broken here, anyway this is safe because it test the params exist in the "params" object
  return to.params[params] !== from.params[params]
}
